<template>
  <table class="table is-bordered">
    <tbody>
      <tr v-for="(row, row_i) in imgdata" :key="`TROW_${row_i}`">
        <td>
          <show-image :src="row.clipart.clipart.file" :width="row.clipart.width" :height="row.clipart.height" />
        </td>
        <td>{{row.title}}</td>
      </tr>
    </tbody>
  </table>
</template>


<script>
import ShowImage from '@/components/General/ShowImage'
export default {
  name : 'show-bar-chart-legend',
  components : {
    ShowImage
  },
  props: {
    data:{
      type: Array
    }
  },
  data(){
    return {
    }
  },
  computed : {
    imgdata(){
      return this.data.filter(row => row.clipart && row.clipart.clipart && row.title)
    }
  }
}
</script>

